import { lazy } from 'react'
import { v4 as uuidv4 } from 'uuid'
import { ROUTE_PATHS } from 'utils/constants/index'
import LoginIcon from '@mui/icons-material/Login'
import CircleOutlinedIcon from '@mui/icons-material/CircleOutlined'
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined'
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined'
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined'
import PaidOutlinedIcon from '@mui/icons-material/PaidOutlined'
import InsightsOutlinedIcon from '@mui/icons-material/InsightsOutlined'
import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined'
import Login from 'pages/Auth/Login'

export const routerList = [
  {
    id: uuidv4(),
    sectionName: 'home',
    sectionChilds: [
      {
        key: uuidv4(),
        label: 'dashboard',
        path: ROUTE_PATHS.dashboard,
        component: lazy(() => import('pages/Dashboard')),
        hasAuth: true,
        hasSideBarOption: true,
        icon: DashboardOutlinedIcon,
        subMenus: []
      },
      {
        key: uuidv4(),
        label: 'dailyStatistics',
        path: ROUTE_PATHS.dailyStatistics,
        component: lazy(() => import('pages/DailyStatistics')),
        hasAuth: true,
        hasSideBarOption: true,
        icon: DashboardOutlinedIcon,
        subMenus: []
      },
      {
        key: uuidv4(),
        label: 'systemSettings',
        path: ROUTE_PATHS.gameSettings,
        component: lazy(() => import('pages/GameSettings')),
        hasAuth: true,
        hasSideBarOption: true,
        icon: SettingsOutlinedIcon,
        subMenus: [
          {
            key: uuidv4(),
            label: 'gameSettings',
            path: ROUTE_PATHS.gameSettings,
            component: lazy(() => import('pages/GameSettings')),
            hasAuth: true,
            hasSideBarOption: true,
            icon: CircleOutlinedIcon
          },
          {
            key: uuidv4(),
            label: 'gamesList',
            path: ROUTE_PATHS.gameList,
            component: lazy(() => import('pages/GamesList')),
            hasAuth: true,
            hasSideBarOption: true,
            icon: CircleOutlinedIcon
          },
          {
            key: uuidv4(),
            label: 'operatorSetting',
            path: ROUTE_PATHS.operatorSetting,
            component: lazy(() => import('pages/OperatorSetting')),
            hasAuth: true,
            hasSideBarOption: true,
            icon: CircleOutlinedIcon
          },
          {
            key: uuidv4(),
            label: 'rightAccess',
            path: ROUTE_PATHS.rightAccess,
            component: lazy(() => import('pages/RightAccess')),
            hasAuth: true,
            hasSideBarOption: true,
            icon: CircleOutlinedIcon
          },
          {
            key: uuidv4(),
            label: 'ipWhitelist',
            path: ROUTE_PATHS.ipWhitelist,
            component: lazy(() => import('pages/IpWhitelist')),
            hasAuth: true,
            hasSideBarOption: true,
            icon: CircleOutlinedIcon
          }

        ]
      },
      {
        key: uuidv4(),
        label: 'Player Online',
        path: ROUTE_PATHS.playerOnline,
        component: lazy(() => import('pages/PlayerOnline')),
        hasAuth: true,
        hasSideBarOption: true,
        icon: GroupsOutlinedIcon,
        subMenus: []
      },
      {
        key: uuidv4(),
        label: 'players',
        path: ROUTE_PATHS.users,
        component: lazy(() => import('pages/PlayerManagement')),
        hasAuth: true,
        hasSideBarOption: true,
        icon: GroupsOutlinedIcon,
        subMenus: []
      },
      {
        key: uuidv4(),
        label: 'transactions',
        path: ROUTE_PATHS.transactions,
        component: lazy(() => import('pages/TransactionsList')),
        hasAuth: true,
        hasSideBarOption: true,
        icon: PaidOutlinedIcon,
        subMenus: []
      },
      {
        key: uuidv4(),
        label: 'gameReports',
        path: ROUTE_PATHS.gameReports,
        component: lazy(() => import('pages/GameReports')),
        hasAuth: true,
        hasSideBarOption: true,
        icon: InsightsOutlinedIcon,
        subMenus: []
      },
      {
        key: uuidv4(),
        label: 'auditLogs',
        path: ROUTE_PATHS.auditLogs,
        component: lazy(() => import('pages/AuditLogs')),
        hasAuth: true,
        hasSideBarOption: true,
        icon: HistoryOutlinedIcon,
        subMenus: [
          {
            key: uuidv4(),
            label: 'gameSettingsLogs',
            path: ROUTE_PATHS.auditLogs,
            component: lazy(() => import('pages/AuditLogs')),
            hasAuth: true,
            hasSideBarOption: true,
            icon: CircleOutlinedIcon
          },
          {
            key: uuidv4(),
            label: 'gamesListLogs',
            path: ROUTE_PATHS.gamesListLogs,
            component: lazy(() => import('pages/GlobalAuditLogs')),
            hasAuth: true,
            hasSideBarOption: true,
            icon: CircleOutlinedIcon
          },
          {
            key: uuidv4(),
            label: 'operatorSettingLogs',
            path: ROUTE_PATHS.operatorSettingLogs,
            component: lazy(() => import('pages/GlobalAuditLogs')),
            hasAuth: true,
            hasSideBarOption: true,
            icon: CircleOutlinedIcon
          },
          {
            key: uuidv4(),
            label: 'rightAccessLogs',
            path: ROUTE_PATHS.rightAccessLogs,
            component: lazy(() => import('pages/GlobalAuditLogs')),
            hasAuth: true,
            hasSideBarOption: true,
            icon: CircleOutlinedIcon
          },
          {
            key: uuidv4(),
            label: 'ipWhitelistLogs',
            path: ROUTE_PATHS.ipWhitelistLogs,
            component: lazy(() => import('pages/GlobalAuditLogs')),
            hasAuth: true,
            hasSideBarOption: true,
            icon: CircleOutlinedIcon
          },
          {
            key: uuidv4(),
            label: 'adminUsersLogs',
            path: ROUTE_PATHS.adminUsersLogs,
            component: lazy(() => import('pages/GlobalAuditLogs')),
            hasAuth: true,
            hasSideBarOption: true,
            icon: CircleOutlinedIcon
          }

        ]
      }

    ]
  },
  {
    id: uuidv4(),
    sectionName: null,
    sectionChilds: [
      {
        key: uuidv4(),
        label: 'login',
        path: ROUTE_PATHS.login,
        component: Login,
        hasAuth: false,
        hasSideBarOption: false,
        icon: LoginIcon,
        subMenus: []
      },
      {
        key: uuidv4(),
        label: 'settings',
        path: `${ROUTE_PATHS.settings}/*`,
        component: lazy(() => import('pages/Settings')),
        hasAuth: true,
        hasSideBarOption: false,
        icon: LoginIcon,
        subMenus: []
      },
      {
        key: uuidv4(),
        label: 'role-permissions',
        path: `${ROUTE_PATHS.rightAccess}/:roleId`, // 👈 change :role to :roleId
        component: lazy(() => import('pages/RightAccess/RolePermissions')),
        hasAuth: true,
        hasSideBarOption: false,
        icon: CircleOutlinedIcon,
        subMenus: []
      }
    ]
  },
  {
    id: uuidv4(),
    sectionName: null,
    sectionChilds: [
      {
        key: uuidv4(),
        label: 'settings',
        path: `${ROUTE_PATHS.settings}/*`,
        component: lazy(() => import('pages/Settings')),
        hasAuth: true,
        hasSideBarOption: false,
        icon: CircleOutlinedIcon,
        subMenus: []
      },
      {
        key: uuidv4(),
        label: 'change-password',
        path: ROUTE_PATHS.changePassword,
        component: lazy(() => import('pages/Auth/ChangePassword')),
        hasAuth: true,
        hasSideBarOption: false,
        icon: CircleOutlinedIcon,
        subMenus: []
      },
      {
        key: uuidv4(),
        label: 'edit-game-setting',
        path: ROUTE_PATHS.editGameSettings,
        component: lazy(() => import('pages/EditGameSetting')),
        hasAuth: true,
        hasSideBarOption: false,
        icon: CircleOutlinedIcon,
        subMenus: []
      }
    ]
  }
]
